import React, { useState, useEffect } from 'react';
import { Modal, Button, SelectControl, TextControl } from '@wordpress/components';
import Cookies from 'js-cookie';

const SettingsModal = ({ isOpen, onClose, onApplySetting, sortOptions = [] }) => {
    const [settings, setSettings] = useState({
        countPerPage: 10,
        defaultSortBy: '',
        defaultSortOrder: 'asc',
    });

    // ✅ Load settings from cookies
    useEffect(() => {
        if (isOpen) {
            const savedSettings = Cookies.get('admin_general_settings');
            if (savedSettings) {
                setSettings(JSON.parse(savedSettings));
            }
        }
    }, [isOpen]);

    // ✅ Handle input changes
    const handleChange = (key, value) => {
        setSettings(prev => ({ ...prev, [key]: value }));
    };

    // ✅ Save and apply
    const handleSaveSettings = () => {
        Cookies.set('admin_general_settings', JSON.stringify(settings), { expires: 7 });
        onApplySetting(settings);
        onClose();
    };

    if (!isOpen) return null;

    return (
        <Modal
            title="General Settings"
            onRequestClose={onClose}
            style={{
                maxWidth: '600px',
                width: '90%',
                minHeight: '300px',
                overflowY: 'auto',
            }}
        >
            <div style={{ display: 'grid', gap: '20px', padding: '10px' }}>
                
                {/* Count Per Page */}
                <div>
                    <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '6px' }}>
                        Count Per Page
                    </label>
                    <TextControl
                        type="number"
                        value={settings.countPerPage}
                        onChange={(value) => handleChange('countPerPage', parseInt(value) || 0)}
                        min={1}
                        style={{ width: '100%' }}
                    />
                </div>

                {/* Default Sort By */}
                <div>
                    <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '6px' }}>
                        Default Sort By
                    </label>
                    <SelectControl
                        value={settings.defaultSortBy}
                        options={[
                            { label: '-- Select Field --', value: '' },
                            ...sortOptions.map(opt => ({
                                label: opt.label || opt.Header || opt.accessor,
                                value: opt.value || opt.accessor,
                            })),
                        ]}
                        onChange={(value) => handleChange('defaultSortBy', value)}
                    />
                </div>

                {/* Default Sort Order */}
                <div>
                    <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '6px' }}>
                        Default Sort
                    </label>
                    <SelectControl
                        value={settings.defaultSortOrder}
                        options={[
                            { label: 'Ascending (A → Z / Low → High)', value: 'asc' },
                            { label: 'Descending (Z → A / High → Low)', value: 'desc' },
                        ]}
                        onChange={(value) => handleChange('defaultSortOrder', value)}
                    />
                </div>
            </div>

            <div style={{ textAlign: 'right', marginTop: '25px' }}>
                <Button
                    isPrimary
                    onClick={handleSaveSettings}
                    style={{ marginRight: '10px' }}
                >
                    Save Settings
                </Button>
                <Button isSecondary onClick={onClose}>
                    Cancel
                </Button>
            </div>
        </Modal>
    );
};

export default SettingsModal;
